import { FormControl, Grid, InputLabel } from '@mui/material';
import { BoardType, ParamsPanelProps } from 'Types';

import MaterialPatternInput from 'designer/MaterialPatternInput';
import MaterialSelector from 'designer/MaterialSelector';
import NumberInput from 'designer/NumberInput';

function QuarterSquareParamsPanel(
  props: ParamsPanelProps<BoardType.QuarterSquare>
) {
  const { params, onParamChange, units } = props;

  return (
    <Grid container direction="column" spacing={2}>
      <Grid container item spacing={2}>
        <Grid item>
          <FormControl variant="standard">
            <InputLabel>Wood 1</InputLabel>
            <MaterialSelector
              onChange={onParamChange('wood1')}
              value={params.wood1}
            />
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl variant="standard">
            <InputLabel>Wood 2</InputLabel>
            <MaterialSelector
              onChange={onParamChange('wood2')}
              value={params.wood2}
            />
          </FormControl>
        </Grid>
        <Grid item>
          <NumberInput
            id="thickness"
            label="Thickness"
            step={1 / 8}
            value={params.thickness}
            onChange={onParamChange('thickness')}
          />
        </Grid>
      </Grid>

      <Grid item>
        <MaterialPatternInput
          id="pattern"
          onChange={onParamChange('pattern')}
          onSelectionChange={() => {}}
          previewHeight={1}
          selection={null}
          units={units}
          value={params.pattern}
        ></MaterialPatternInput>
      </Grid>
    </Grid>
  );
}

export default QuarterSquareParamsPanel;
